<template>
  <div class="window" ref="window" :class="{ active, centered }">
    <div v-if="!headless" class="header" ref="header">
      <div class="close" @click="() => hide()">
        <font-awesome-icon :icon="faTimes" />
      </div>
    </div>
    <div class="body">
      <div class="close" @click="() => hide()">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
      </div>
      <slot name="body" ref="body" />
    </div>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import { Draggable } from 'gsap/all';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'Window',
  components: {
    FontAwesomeIcon
  },
  props: {
    headless: Boolean,
    centered: Boolean
  },
  setup(props, { emit }) {
    const window = ref(null);
    const header = ref(null);
    const body = ref(null);
    const active = ref(false);

    const show = () => {
      active.value = true;
      emit('show');
    };

    const hide = () => {
      active.value = false;
      emit('hide');
    };

    watch(window, (w) => {
      if (w) {
        Draggable.create(w, { type: 'x,y', edgeResistance: 0.65, bounds: 'body', inertia: true });
      }
    });

    return {
      window,
      header,
      body,
      show,
      hide,
      active,
      faTimes
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

.window {
  position: fixed;
  top: 150px;
  left: 150px;
  z-index: 99999 !important;
  border-radius: 10px;
  overflow: hidden;
  background-color: $babyPowder;
  box-shadow: 0px 3px 6px #00000029;
  display: none;
  cursor: move !important;

  &.active {
    display: block;
  }

  &.centered {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .header {
    padding: 5px 10px;
    background-color: $babyPowder;
    text-align: right;
  }

  .close {
    svg {
      transition: all .2s ease-in-out;
      cursor: pointer;
    }
  }

  .body {
    position: relative;
    padding: 30px;

    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      opacity: 1;

      .line {
          height: 1px;
          width: 20px;
          background-color: $independence;
          transform-origin: center;
          margin: 0 auto;
          transition: all .2s ease-in-out;
      }

      .line-1 {
          transform: translateY(10px) rotate(45deg);
      }

      .line-2 {
          transform: translateY(10px) rotate(135deg);
      }

      &:hover {
        .line {
          background-color: $geranium;
        }
      }
    }
  }
}
</style>
